exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.po-analysis-chart[data-v-54ba08f4] {\r\n  width: 100%;\r\n  height: 100%;\n}\r\n", ""]);

